export enum OnlineState {
    Offline,
    Online,
}
